import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

import { Provider } from "react-redux";
import store from "./store/index";

import { BrowserRouter } from 'react-router-dom';

if (document.getElementById('root')) {
ReactDOM.hydrate(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>,
    document.getElementById('root'));
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js